import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AlertService } from '../../services/alert.service';
import { LoginService } from '../../services/login.service';

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {

    progress!: boolean;

    redirect!: string | null;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private alertService: AlertService,
        private loginService: LoginService
    ) {
    }

    ngOnInit() {
        this.progress = false;
        this.redirect = this.route.snapshot.queryParamMap.get('redirect');
    }

    ngOnDestroy() {
    }

    login(email: string, password: string) {
        this.progress = true;
        this.loginService.login(email, password).subscribe({
            next: (value: any) => {
                console.log('LoginComponent.login.loginService.login.value', value);
                let accessTokenV2: string = value.access_token;
                let refreshTokenV2: string = value.refresh_token;
                this.loginService.whoami(accessTokenV2).subscribe({
                    next: (value: any) => {
                        console.log('LoginComponent.login.loginService.login.loginService.whoami.value', value);
                        let accountId: string = value.accountId;
                        let authorities: string = value.authorities;
                        if (authorities.includes('ROLE_ADMIN')) {
                            this.loginService.v1Auth(accountId, accessTokenV2).subscribe({
                                next: (value: any) => {
                                    console.log('LoginComponent.login.loginService.login.loginService.whoami.loginService.v1Auth.value', value);
                                    let accessTokenV1: string = value.token;
                                    let refreshTokenV1: string = value.refreshToken;
                                    this.loginService.getJwtByToken(accessTokenV1).subscribe({
                                        next: (value: any) => {
                                            console.log('LoginComponent.login.loginService.login.loginService.whoami.loginService.v1Auth.loginService.getJwtByToken.value', value);
                                            let role: string = value.role;
                                            if (role.toUpperCase() == 'ADMIN') {
                                                this.progress = false;
                                                let now = Date.now();
                                                this.loginService.accessTokenV2 = accessTokenV2;
                                                this.loginService.accessTokenV1 = accessTokenV1;
                                                this.loginService.refreshTokenV2 = refreshTokenV2;
                                                this.loginService.refreshTokenV1 = refreshTokenV1;
                                                this.loginService.lastRefreshTimeV2 = now;
                                                this.loginService.lastRefreshTimeV1 = now;
                                                if (this.redirect) {
                                                    this.router.navigate([this.redirect]);
                                                } else {
                                                    this.router.navigate(['/']);
                                                }
                                            } else {
                                                this.progress = false;
                                                this.pushAlert('alert-warning', 'Admin Required');
                                            }
                                        },
                                        error: (error: any) => {
                                            console.log('LoginComponent.login.loginService.login.loginService.whoami.loginService.v1Auth.loginService.getJwtByToken.error', error);
                                            this.progress = false;
                                            this.pushAlertByErrorStatus(error);
                                        }
                                    });
                                },
                                error: (error: any) => {
                                    console.log('LoginComponent.login.loginService.login.loginService.whoami.loginService.v1Auth.error', error);
                                    this.progress = false;
                                    this.pushAlertByErrorStatus(error);
                                }
                            });
                        } else {
                            this.progress = false;
                            this.pushAlert('alert-warning', 'Admin Required');
                        }
                    },
                    error: (error: any) => {
                        console.log('LoginComponent.login.loginService.login.loginService.whoami.error', error);
                        this.progress = false;
                        this.pushAlertByErrorStatus(error);
                    }
                });
            },
            error: (error: any) => {
                console.log('LoginComponent.login.loginService.login.error', error);
                this.progress = false;
                this.pushAlertByErrorStatus(error);
            }
        });
    }

    private pushAlertByErrorStatus(error: any) {
        let content: string;
        if (error.status == 401) {
            content = 'Unauthorized';
        } else if (error.status == 403) {
            content = 'Forbidden';
        } else if (error.status == 422) {
            content = 'Unprocessable Entity';
        } else if (error.status >= 400 && error.status < 500) {
            content = 'Client Error';
        } else if (error.status >= 500 && error.status < 600) {
            content = 'Server Error';
        } else {
            content = 'Error';
        }
        this.pushAlert('alert-danger', content);
    }

    private pushAlert(cssClass: string, content: string) {
        this.alertService.pushAlert(cssClass, content);
    }
}
